import { create } from 'zustand';

export const useOfflineStore = create((set) => ({
  isOnline:      navigator.onLine,
  pendingCount:  0,
  syncing:       false,
  syncedAt:      null,
  // Progress during an active sync: how many have been processed / total in this run
  syncProgress:  { current: 0, total: 0 },
  // How many were successfully synced in the last completed run
  syncedCount:   0,
  // How many checkout operations were synced (need payment recording in Billing)
  checkoutsSynced: 0,

  setOnline:        (v)  => set({ isOnline: v }),
  setPendingCount:  (n)  => set({ pendingCount: Math.max(0, n) }),
  incrementPending: ()   => set((s) => ({ pendingCount: s.pendingCount + 1 })),
  decrementPending: (n = 1) => set((s) => ({ pendingCount: Math.max(0, s.pendingCount - n) })),
  setSyncing:       (v)  => set({ syncing: v }),
  setSyncedAt:      (t)  => set({ syncedAt: t }),
  setSyncProgress:   (p) => set({ syncProgress: p }),
  setSyncedCount:    (n) => set({ syncedCount: n }),
  setCheckoutsSynced:(n) => set({ checkoutsSynced: n }),
  clearCheckoutsSynced: () => set({ checkoutsSynced: 0 }),
}));
